import { FragmentMetadata } from './fragment-metadata.js';
/**
 * Store that keeps all the fragment metadata structure in runtime.
 */
class MetadataStore {
    constructor() {
        this.store = new Map();
    }
    /**
     * Register a new fragment in the store.
     *
     * @param name - Fragment name.
     * @param rootNode - Root node of the fragment.
     *
     * @throws When a fragment with the same name already exists in the store.
     */
    register(name, rootNode) {
        if (this.store.has(name)) {
            throw new Error(`[Metadata Store] A fragment called '${name}' already exists within the store.`);
        }
        const fragmentMetadata = new FragmentMetadata(name, rootNode);
        fragmentMetadata.validate();
        this.store.set(name, fragmentMetadata);
    }
    /**
     * Delete a fragment from the store.
     *
     * @param name - Fragment name.
     */
    unregister(name) {
        this.store.delete(name);
    }
    /**
     * Retrieves a {@link FragmentMetadata fragment} from the store, if it exists.
     *
     * @param name - Fragment name.
     */
    get(name) {
        return this.store.get(name) ?? null;
    }
    /**
     * Check if a fragment exists within the store.
     *
     * @param name - Fragment name.
     */
    has(name) {
        return this.store.has(name);
    }
}
export { MetadataStore, };
//# sourceMappingURL=metadata-store.js.map